export enum ContextName {
  Inquiry = 'Inquiry',
}
